import React from "react"
import Modal from "../../../components/My/Modal";
import {Button} from "../../../components/My/Button";



const ApproveModal = ({visible, close, accept, text, title}) => {

    if (!visible) return null

    return (
        <>
            <Modal title={title ? title : "Upozornění"}
                   body={<div>{text}</div>}
                   visible={visible}
                   close={() => close()}
                   footer={<>
                       <Button text={"Potvrdit"} onClick={() => accept()}/>
                   </>
                   }
            />
        </>
    )
}

export default ApproveModal
